const CustomInput = ({ errors, name, placeholder, register, floatingLabel, ...props }) => {
  const hasError = !!errors?.[name];
  const showFloatingLabel = Boolean(placeholder);

  return (
    <div className="relative">
      <input
        id={name}
        placeholder={floatingLabel ? " " : placeholder}
        autoComplete="off"
        autoCorrect="off"
        autoCapitalize="off"
        spellCheck="false"
        data-form-type="other"
        autoSave="off"
        results="off"
        aria-autocomplete="none"
        className={`peer w-full rounded-[4px] px-3  text-base outline-none transition-all
          ${floatingLabel ? "pb-1 pt-4 h-[56px]" : "py-2"}
          ${
            hasError
              ? "border-red-500 focus:border-red-500"
              : "border-gray-200 hover:border-[#8F8F8F] focus:!border-darkslateblue"
          }
        `}
        style={{
          border: hasError ? "1px solid #FF0000" : "1px solid #CFCFCF",
          borderColor: hasError ? "#FF0000" : "#CFCFCF",
          "&:hover": {
            borderColor: hasError ? "#FF0000" : "#8F8F8F",
          },
          "&:focus": {
            borderColor: hasError ? "#FF0000" : "#193861",
          },
        }}
        {...props}
        {...register}
      />

      {/* Only render label if placeholder exists */}
      {floatingLabel && (
        <label
          htmlFor={name}
          className={`peer-placeholder-shown:-translate-y-1/5 pointer-events-none absolute left-3 top-1 text-[14px]
            transition-all peer-placeholder-shown:top-5 peer-placeholder-shown:text-base
            peer-focus:top-1 peer-focus:text-[14px]
            ${hasError ? "text-red-500" : "text-smokey-grey"}
          `}
        >
          {placeholder}
        </label>
      )}

      {hasError && (
        <p className="mt-1 text-xs text-red-500">{errors[name]?.message}</p>
      )}
    </div>
  );
};

export default CustomInput;
